import { render, staticRenderFns } from "./ComponentPlus.vue?vue&type=template&id=e435fef2&scoped=true&"
import script from "./ComponentPlus.vue?vue&type=script&lang=js&"
export * from "./ComponentPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e435fef2",
  null
  
)

export default component.exports